module.exports = __webpack_public_path__ + "img/telegram.5f3f858b.svg";